const hasPermission = (state, getters, rootState, rootGetters) => {
    return rootGetters['auth/appAccesses']?.includes('CMS');
};

export default {
    hasPermission,
};
